/**
 * useSocialStrip — TanStack-Query wrapper around /api/social/dashboard-strip.
 *
 * One round-trip, three consumers:
 *   • <SocialPressureStrip />     — "12 studiers in 4 rooms" carousel
 *   • <UniversityRankChip />      — "Top 8% at Legon Hall" header chip
 *   • <ActivePactChip />          — "Streak with Ama · day 7" header chip
 *
 * staleTime=45s — live presence shouldn't lag more than a minute, but
 * we also don't want to spam the backend on every dashboard navigation.
 */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSocialStrip = () => useQuery({
  queryKey: ['social', 'dashboard-strip'],
  queryFn: async () => (await axios.get(`${API}/social/dashboard-strip`)).data,
  staleTime: 45_000,
  refetchOnWindowFocus: false,
});
